import React from 'react';
import { Typography } from '@mui/material';

/** Shown on feed-backed cards while the activity window is still loading. */
export const FeedLoadingHint = () => (
  <Typography
    sx={{
      display: 'block',
      fontSize: '0.68rem',
      color: 'rgba(0,0,0,0.42)',
      fontStyle: 'italic',
      mt: 0.5,
      lineHeight: 1.35,
    }}
  >
    Loading details…
  </Typography>
);

/** Shown once when we stop loading after the event cap (partial window). */
export const FeedCapBanner = ({ maxEvents }) => (
  <Typography
    sx={{
      fontSize: '0.78rem',
      color: 'rgba(0,0,0,0.55)',
      lineHeight: 1.5,
      px: { xs: 1.25, sm: 1.5 },
      py: 1,
      borderRadius: '10px',
      bgcolor: 'rgba(0,0,0,0.03)',
      border: '1px solid rgba(0,0,0,0.06)',
    }}
  >
    This period has more activity than we can load at once. Visitor, session, and
    activity numbers below use the most recent {maxEvents.toLocaleString()} events
    only — they may be lower than your headline totals.
  </Typography>
);
